import { render, staticRenderFns } from "./modify-manage.vue?vue&type=template&id=1f3ffa18&scoped=true"
import script from "./modify-manage.vue?vue&type=script&lang=ts"
export * from "./modify-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3ffa18",
  null
  
)

export default component.exports